import React from 'react';
import { DashboardContextProvider } from 'src/context/DashboardContextProvider';

const withDashboardProvider = (Component) => (props) => {
  return (
    <DashboardContextProvider>
      <Component {...props} />
    </DashboardContextProvider>
  );
};

export default withDashboardProvider;